import type { Emisor } from '@/api/types';
import { readJson, writeJson } from '@/lib/storage';

export type OnboardingStep = 1 | 2 | 3 | 4;
const SKIP_KEY = 'facturita.onboarding.skipped';

/** Which step the account should resume at, derived from server state. 4 = nothing missing. */
export function onboardingStep(e: Emisor | null | undefined): OnboardingStep {
  if (!e || !e.ruc || !e.razonSocial) return 1;
  const hasPunto = e.establecimientos.some((x) => x.puntos.length > 0);
  if (e.establecimientos.length === 0 || !hasPunto) return 2;
  if (!e.isSignatureConfigured) return 3;
  return 4;
}

export function onboardingSkipped(): boolean {
  return readJson<boolean>(SKIP_KEY, false);
}
export function setOnboardingSkipped(v: boolean) {
  writeJson(SKIP_KEY, v);
}
